module.exports = __webpack_public_path__ + "static/media/ms-icon_144x144.5bb14001.jpg";